import { lazy } from 'react'
import lazyLoad from './LazyLoad'

// ubox详情相关
export const breakingRouter = [
  {
    element: lazyLoad(lazy(() => import('@/pages/breaking/simpleDetail'))),
    path: '/breaking/simpleDetail',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/breaking/keyList'))),
    path: '/breaking/keyList',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/breaking/cardRePort'))),
    path: '/breaking/cardRePort',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/breaking/liveList'))),
    path: '/breaking/liveList',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/breaking/result'))),
    path: '/breaking/result',
  },
  {
    element: lazyLoad(lazy(() => import('@/pages/breaking/groupOrder'))),
    path: '/breaking/groupOrder',
  }
  //
  // breaking/result
]